export const V2_EXECUTION_EVENTS = {
    FAILED: "session.execution.failed",
    INTERRUPTED: "session.execution.interrupted",
} as const;
